import FormCountrySelector from "@babackapp/react-hook-forms-components/form-country-selector";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormSaveButton from "@babackapp/react-hook-forms-components/form-save-button";
import useTranslation from "@babackapp/translations/use-translation";
import { Form, FormField } from "@babackapp/ui/components/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const formSchema = z.object({
  harmonizedSystemCode: z.string(),
  countryOfOrigin: z.object({
    name: z.string(),
    code: z.string(),
  }),
 });

export type ArticleItemFormValues = z.infer<typeof formSchema>;

type ArticleItemFormProps = {
  defaultValues?: z.infer<typeof formSchema>;
  onSubmit: (data: ArticleItemFormValues) => void;
  onRemove?: () => void;
};

const DEFAULT_VALUES = {
  harmonizedSystemCode: "",
  countryOfOrigin: {
    name: "",
    code: "",
  },
};

export default function ArticleItemForm({
  defaultValues = DEFAULT_VALUES,
  onSubmit,
}: ArticleItemFormProps) {
  const t = useTranslation();

  const form = useForm<ArticleItemFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  });

  const _onSubmit = form.handleSubmit((data) => {
    onSubmit({
      harmonizedSystemCode: data.harmonizedSystemCode,
      countryOfOrigin: data.countryOfOrigin,      
    });
  });

  return (
    <Form {...form}>
      <form
        onSubmit={_onSubmit}
        className="flex flex-col justify-start gap-8 mt-[16px]"
      >
        <FormField
          control={form.control}
          name="harmonizedSystemCode"
          render={({ field }) => (
            <FormInput
              label={t("returnDetail.update.harmonized")}
              {...field}
            />
          )}
        />
         <FormField
          control={form.control}
          name="countryOfOrigin"
          render={({ field }) => (
            <FormCountrySelector
              label={t("returnDetail.update.countryOfOrigin")}
              value={field.value}
              onValueChange={field.onChange}
            />
          )}
        />  

          <FormSaveButton />
      </form>
    </Form>
  );
}
